import { useTraderPayoutTraderServiceGetRate } from '~/generated/payoutBackend/trader';

interface UseRateOptions {
    enabled?: boolean;
}

export const useRate = ({ enabled = true }: UseRateOptions = {}) => {
    return useTraderPayoutTraderServiceGetRate<string | undefined>({
        query: {
            enabled,
            select: ({ rate }) => rate?.value,
            refetchInterval: 5000,
        },
    });
};
